import { DeleteTwoTone, EditTwoTone, EyeTwoTone } from "@ant-design/icons";
import { Tooltip } from "antd";
import React from "react";
import { TooltipMessage } from "../../../../common/data/TooltipMsg";
import "./index.css";
import { Routes } from "../../../../common/Routes";
import { useHistory } from "react-router-dom";
import { KeyConditionAction } from "../../../../pages/userGroups/KeyCondition/model";
import { sendUserGroupDetailsEvent, UserGroupDetailsAction } from "../../../matomoClient";

function ListKeyConditions(
  {
    listOfKeyConditions,
    haveMembershipConditionsEditAccess,
    userGroupUniqueName,
    userGroupTypeUniqueName,
  }) {
  const history = useHistory();

  function RenderConditionIcon({ children, tooltipmsg }) {
    return (
      <div className="icon-single">
        <Tooltip
          placement="top"
          title={tooltipmsg}
        >
          {children}
        </Tooltip>
      </div>
    );
  }

  function navigateToMemberPreview(conditionId) {
    history.push(
      `${Routes.UserGroups.basePath}/${userGroupTypeUniqueName}/${userGroupUniqueName}/key-condition/preview/${conditionId}`,
    );
  }

  function navigateToEditConditionPage(conditionId) {
    history.push(
      `${Routes.UserGroups.basePath}/${userGroupTypeUniqueName}/${userGroupUniqueName}/key-condition/${KeyConditionAction.EDIT}/${conditionId}`,
    );
  }

  function navigateToDeleteConditionPage(conditionId) {
    history.push(
      `${Routes.UserGroups.basePath}/${userGroupTypeUniqueName}/${userGroupUniqueName}/key-condition/${KeyConditionAction.DELETE}/${conditionId}`,
    );
  }

  function renderKeyConditionOptions(conditionId) {
    const twoToneColor = "#173d4d";
    if (haveMembershipConditionsEditAccess === true) {
      return (
        <div className="outside-key-condition-box-options">
          <div className="key-condition-box-options">
            <div className="icons-collection">
              <RenderConditionIcon tooltipmsg={TooltipMessage.viewKeyConditionMembers}>
                <EyeTwoTone
                  className="icon-style"
                  twoToneColor={twoToneColor}
                  onClick={() => {
                    navigateToMemberPreview(conditionId);
                    sendUserGroupDetailsEvent(
                      UserGroupDetailsAction.ViewKeyConditionMembers,
                      TooltipMessage.viewKeyConditionMembers,
                    );
                  }}
                />
              </RenderConditionIcon>
              <RenderConditionIcon tooltipmsg={TooltipMessage.editKeyCondition}>
                <EditTwoTone
                  className="icon-style"
                  twoToneColor={twoToneColor}
                  onClick={() => {
                    navigateToEditConditionPage(conditionId);
                    sendUserGroupDetailsEvent(
                      UserGroupDetailsAction.EditKeyCondition,
                      TooltipMessage.editKeyCondition,
                    );
                  }}
                />
              </RenderConditionIcon>
              <RenderConditionIcon tooltipmsg={TooltipMessage.deleteKeyCondition}>
                <DeleteTwoTone
                  className="icon-style"
                  twoToneColor={twoToneColor}
                  onClick={() => {
                    navigateToDeleteConditionPage(conditionId);
                    sendUserGroupDetailsEvent(
                      UserGroupDetailsAction.DeleteKeyCondition,
                      TooltipMessage.deleteKeyCondition,
                    );
                  }}
                />
              </RenderConditionIcon>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  return (
    <>
      {listOfKeyConditions.map((keyCondition, index) => {
        return (
          <div
            key={keyCondition.key}
            className="list-key-conditions"
          >
            <div className="key-condition-box">
              {renderKeyConditionOptions(keyCondition.key)}
              {keyCondition.render()}
            </div>
            {listOfKeyConditions.length - 1 !== index ? (
              <div className="or-operator-name-padding">
                <div className="or-operator-name">OR</div>
              </div>
            ) : null}
          </div>
        );
      })}
    </>
  );
}

export default ListKeyConditions;
